/**
 * Checks if a string is a valid URL
 */
export function isValidUrl(urlString: string): boolean {
  try {
    new URL(urlString);
    return true;
  } catch {
    return false;
  }
}

/**
 * Generate HTML for an address to be displayed on templates
 */
export function getAddressHtml(
  recipientName: string,
  addressLine1?: string,
  addressLine2?: string,
  city?: string,
  state?: string,
  zip?: string
): string {
  if (!recipientName) return '';
  
  if (addressLine1 && city && state && zip) {
    return `<div style="font-family: 'Lato', Arial, sans-serif; font-size: 12px; line-height: 1.5; text-align: center;">
      ${recipientName}<br>
      ${addressLine1}${addressLine2 ? `<br>${addressLine2}` : ''}<br>
      ${city}, ${state} ${zip}
    </div>`;
  } else {
    return `<div style="font-family: 'Lato', Arial, sans-serif; font-size: 12px; line-height: 1.5; text-align: center;">
      ${recipientName}<br>
      123 Sample Street<br>
      Anytown, CA 12345
    </div>`;
  }
} 